import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { Breadcrumbs, Button, MenuItem, MenuList, PopoverRoot, PopoverTrigger, PopoverPopup, Stack } from '@ff-it/ui';
import { useRealUser, useSessionScope } from 'services';
import { useMediaQuery } from 'hooks';
import { crumbWrap, headerLeft, topNav, topNavBreadcrumbs } from './TopNav.css';
import { Icon } from './Icon';
import { Impersonation } from './Impersonation';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { GlobalSearch } from './GlobalSearch';
import { EnterpriseSwitcher } from './EnterpriseSwitcher';
import { UserAvatar } from './UserAvatar';
import { IndicatorBadge } from 'core/Indicators';
import { RealtimeStatus } from './RealtimeStatus';

export function TopNav(): ReactElement {
  const user = useRealUser();
  const scope = useSessionScope();
  const compact = useMediaQuery('(max-width: 991.98px)');

  return (
    <nav className={topNav} id="top-nav">
      <div className={headerLeft}>
        <EnterpriseSwitcher />
        <div className={crumbWrap}>
          <Breadcrumbs className={topNavBreadcrumbs} />
        </div>
      </div>
      <Stack direction="horizontal" mr="2" align="center" flexShrink={0}>
        <RealtimeStatus />
        <GlobalSearch compact={compact} />
        <Impersonation compact={compact} />
        {scope.kind === 'AGENCY' ? (
          <IndicatorBadge counter="unseen_notifications" placement="bottom-end">
            <Button variant="ghost" size="xs" icon="inbox" asChild>
              <EnterpriseLink to="notifications" />
            </Button>
          </IndicatorBadge>
        ) : null}

        <PopoverRoot>
          <PopoverTrigger>
            <Button variant="ghost" size="xxs">
              <UserAvatar user={user} size="xs" noTooltip />
            </Button>
          </PopoverTrigger>
          <PopoverPopup placement="bottom-end">
            <MenuList>
              <MenuItem label={user.email} prefix={<Icon icon="user" />} component={EnterpriseLink} to="/profile" />
              <MenuItem label="Sign out" prefix={<Icon icon="right-from-bracket" />} component={NavLink} to="/logout" />
            </MenuList>
          </PopoverPopup>
        </PopoverRoot>
      </Stack>
    </nav>
  );
}
